import { ISynth } from "./abstraction/ISynth";


export class MidiSynth implements ISynth {

    protected _isOpen: boolean;

    constructor(out: MIDIOutput) {

        this.out = out;
        this.instrument = 41;
    }

    async openAsync(): Promise<void> {

        if (this._isOpen)
            return;

        await this.out.open();

        this._isOpen = true;
    }

    async closeAsync(): Promise<void> {

        if (!this._isOpen)
            return;
        await this.resetAsync();
        await this.out.close();
        this._isOpen = false;
    }

    setVolumeAsync(value: number): Promise<void> {

        throw new Error("Method not implemented.");
    }

    resetAsync() {
        this.noteOff();
        this.out.send([0xF0, 0x7E, 0x7F, 0x09, 0x01, 0xF7]);
        this.out.send([0xC0, this.instrument]);
    }

    playNote(note: number, volume: number, duration: number, startTime?: number): void {

        this.out.send([0x90, note, Math.round(volume * 127)], (startTime ?? 0) * 1000);
        this.out.send([0x80, note, 0], ((startTime ?? 0) + duration) * 1000);
    }

    noteOn(note: number, volume: number): void {
        this.out.send([0x90, note, volume]);
    }

    noteOff(note?: number, startTime?: number): void {
        if (!note)
            this.out.send([0xB0, 0x7B, 0x00], (startTime ?? 0) * 1000);
        else
            this.out.send([0x80, note, 0], (startTime ?? 0) * 1000);
    }

    get deviceId() {
        return this.out.name;
    }


    instrument: number;

    readonly out: MIDIOutput;

}